import React, { useEffect, useState } from 'react';
import { RouteChildrenProps } from 'react-router-dom';
import { Box, constants } from '@match/react-component-library';
import api from 'utils/api-services';
import { Topic } from 'types';
import { TopicView } from 'modules/components';
import { useCurrentCategoryName } from 'modules/hooks';

const { SPACE } = constants;

interface RouteParams {
  categoryId?: string;
  topicId?: string;
  match?: any;
}

const MobiTopicPage: React.FunctionComponent<RouteChildrenProps<RouteParams>> = (props) => {
  const [currentTopic, setCurrentTopic] = useState<Topic | undefined>();
  const [error, setError] = useState('');

  const { currentCategoryName } = useCurrentCategoryName();

  const { match } = props;
  let currentTopicId: number | undefined;
  if (match) {
    currentTopicId = Number(match.params.topicId) || undefined;
  }

  useEffect(() => {
    if (currentTopicId) {
      api
        .getTopic(currentTopicId)
        .then((res) => {
          setCurrentTopic(res as Topic);
        })
        .catch(() => setError('Invalid topic'));
    } else {
      // clear topic when routing from a topic view to a category view
      setCurrentTopic(undefined);
    }
  }, [currentTopicId]);

  if (!currentTopic) return null;
  if (error) console.log(error);

  const { answer, categoryId, id, title } = currentTopic;

  return (
    <Box center maxWidth="95%" paddingX={SPACE.XLARGE}>
      <TopicView
        answer={answer}
        categoryId={categoryId}
        categoryName={currentCategoryName}
        id={id}
        showHelpBreadcrumb
        title={title}
      />
    </Box>
  );
};

export default MobiTopicPage;
